<template>
    <div id="modal-help" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Help</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{$t('help_av_source')}}</p>
                    <p>{{$t('help_av_in_use')}}</p>
                    <p>{{$t('help_latest_browser')}}</p>
                    <p>{{$t('help_if_none')}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {}
</script>
